import CreditBuildingScreen from 'features/believe/CreditBuildingScreen/CreditBuildingScreen';
import React from 'react';

export default function CreditBuildingDetailsPage() {
  return <CreditBuildingScreen />;
}
